import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "alert alert-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RestorantMarker = _resolveComponent("RestorantMarker")!
  const _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_ctx.center)
    ? (_openBlock(), _createBlock(_component_GMapMap, {
        key: 0,
        class: "h-100",
        center: _ctx.center,
        zoom: 15,
        "map-type-id": "roadmap"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markers, (m, index) => {
            return (_openBlock(), _createBlock(_component_GMapMarker, {
              key: index,
              position: m.position,
              clickable: true,
              icon: {
            url: require('@/assets/logo-small.svg'),
            scaledSize: { width: 50, height: 50 },
        },
              closeclick: true,
              onClick: ($event: any) => (_ctx.openMarker(m.id)),
              onCloseclick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMarker(null)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_GMapInfoWindow, {
                  opened: _ctx.openedMarkerID === m.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RestorantMarker, {
                      restorant: m.restorant
                    }, null, 8, ["restorant"])
                  ]),
                  _: 2
                }, 1032, ["opened"])
              ]),
              _: 2
            }, 1032, ["position", "icon", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["center"]))
    : (_ctx.locationDetectionFailed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Location detection failed. Please enable location detection in your browser. "))
      : _createCommentVNode("", true)
}